import React from 'react'
import Header from './Reusables/Header'
import DownloadImg from "../assests/download.svg";
import RBMBudgetTable from './Tables/RBMBudgetTable';
import axiosRequest from "../api/axios";
import SnackBarComponent from "./Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { CSVLink } from "react-csv";
import PeriodSelector from './PeriodSelector';
const RBMBuBudgetSummary = () => {
  const [filtersData, setfiltersData] = React.useState({});
  const [brandListData, setbrandListData] = React.useState([]);
  const [productListData, setproductListData] = React.useState([]);
  const [selectedProduct, setselectedProduct] = React.useState("");
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [rows, setrows] = React.useState([]);
  const [loaderFilter, setLoaderFilter] = React.useState(false);
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");
  const [filtersDataSum, setfiltersDataSum] = React.useState({});

  let sum_data = {
    "m1_qty_sum" :0,
    "m1_value_sum" :0,
    "m1_nsp_sum" :0 ,
    "m2_qty_sum" : 0 ,
    "m2_value_sum" :0 ,
    "m2_nsp_sum" :0 ,
    "m3_qty_sum" : 0 ,
    "m3_value_sum" :0 ,
    "m3_nsp_sum" :0
  }
  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }
  
  let brandComponent = [];
  brandListData.forEach((item, index) => {
    brandComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
 
  let productComponent = [];
  productListData.forEach((item, index) => {
    productComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  const handleChangeBrand = (event) => {
    const temp = event.target.value;
    let prodlist=[]
    for (let item of filtersData) {
      if(item['brandname'] == temp){
        if(event.target.value == "All"){
          prodlist = [...item["productname"]]
        }else{
          prodlist = ["All",...item["productname"]]
        }
        
      }
    }
   
    setproductListData(prodlist)
    setselectedProduct(prodlist[0])
    setselectedBrand(temp);
   
  };
  
 
  const handleClose = () => {
    setOpensb(false);
  };
 

  const handleChangeProduct = (event) => {
    const temp = event.target.value;
    setselectedProduct(temp);
   
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/rbmbudgetfiltersoutputdata",
      method: "POST",
      headers: api_headers,
      data: {
        brandname: selectedBrand,
        prodname:selectedProduct,
        rbmcode:localStorage.getItem("rbmcode"),
        teamcode: localStorage.getItem("teamcode"),
        quarter:localStorage.getItem("quarter"),
        year:localStorage.getItem("year"),

      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        handleSnackBar("Data Loaded Successfully", "success");
        let tot_data = data?.data?.data
        let m1_qty_sum = 0 
        let m1_value_sum =0 
        let m1_nsp_sum =0 
        let m2_qty_sum = 0 
        let m2_value_sum =0 
        let m2_nsp_sum =0 
        let m3_qty_sum = 0 
        let m3_value_sum =0 
        let m3_nsp_sum =0 
        
        for (let i = 0; i < tot_data?.length; i++) { 
          m1_qty_sum = m1_qty_sum+ parseFloat(tot_data[i]["m1_adjusted_budget_unit"] != null ? tot_data[i]["m1_adjusted_budget_unit"] : 0)
          m1_value_sum = m1_value_sum + parseFloat(tot_data[i]["m1_adjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0)
          m1_nsp_sum = m1_nsp_sum + parseFloat( tot_data[i]["nsp1"] != null ? tot_data[i]["nsp1"] : 0)
          m2_qty_sum = m2_qty_sum+ parseFloat(tot_data[i]["m2_adjusted_budget_unit"] != null ? tot_data[i]["m2_adjusted_budget_unit"] : 0)
          m2_value_sum = m2_value_sum + parseFloat(tot_data[i]["m2_adjusted_budget_value"] != null ? tot_data[i]["m2_adjusted_budget_value"] : 0)
          m2_nsp_sum = m2_nsp_sum + parseFloat(tot_data[i]["nsp2"] != null ? tot_data[i]["nsp2"] : 0)
          m3_qty_sum = m3_qty_sum+ parseFloat( tot_data[i]["m3_adjusted_budget_unit"] != null ? tot_data[i]["m3_adjusted_budget_unit"] : 0)
          m3_value_sum = m3_value_sum + parseFloat(tot_data[i]["m3_adjusted_budget_value"] != null ? tot_data[i]["m3_adjusted_budget_value"] : 0)
          m3_nsp_sum = m3_nsp_sum + parseFloat(tot_data[i]["nsp3"] != null ? tot_data[i]["nsp3"] : 0)
        }
        sum_data['m1_qty_sum'] = parseFloat(m1_qty_sum).toFixed( 2 );
        sum_data['m1_value_sum'] = parseFloat(m1_value_sum).toFixed( 2 );
        sum_data['m1_nsp_sum'] =  parseFloat(m1_nsp_sum).toFixed( 2 );
        sum_data['m2_qty_sum'] =  parseFloat(m2_qty_sum).toFixed( 2 );
        sum_data['m2_value_sum'] = parseFloat(m2_value_sum).toFixed( 2 );
        sum_data['m2_nsp_sum'] =  parseFloat(m2_nsp_sum).toFixed( 2 );
        sum_data['m3_qty_sum'] =  parseFloat(m3_qty_sum).toFixed( 2 );
        sum_data['m3_value_sum'] =  parseFloat(m3_value_sum).toFixed( 2 );
        sum_data['m3_nsp_sum'] =  parseFloat(m3_nsp_sum).toFixed( 2 );
        setfiltersDataSum(sum_data)
        // setfiltersOutputData()
       
      } else {
        
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };


  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/getfiltersdatarbmbudget",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: localStorage.getItem("teamcode"),
        rbmcode:localStorage.getItem("rbmcode"),
        year:localStorage.getItem("year"),
        quarter:localStorage.getItem("quarter"),

      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = [];

        setfiltersData(data?.data?.data);
       
        for (let brand of data?.data?.data) {
          temp_list.push(brand["brandname"]);
        }
        setbrandListData(temp_list)
       
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
        
      }
    });
  };
React.useEffect(() => {
    getfiltersdata();
    // gettabledata();
    setQuarter(localStorage.getItem('quarter'))
    //logic to display month name based on Quarter
    if (localStorage.getItem('quarter') == "Q1") {
      setMonth1("Jan");
      setMonth2("Feb");
      setMonth3("Mar");
    } else if (localStorage.getItem('quarter') == "Q2") {
      setMonth1("Apr");
      setMonth2("May");
      setMonth3("Jun");
    } else if (localStorage.getItem('quarter') == "Q3") {
      setMonth1("Jul");
      setMonth2("Aug");
      setMonth3("Sep");
    } else if (localStorage.getItem('quarter') == "Q4") {
      setMonth1("Oct");
      setMonth2("Nov");
      setMonth3("Dec");
    }
  }, []);
  let columns_buh = [
    { key: "id", label: "ID"},
    {
      key: 'rbmname',
      label: 'RBM Name',
    },
    {
      key: 'rbmcode',
      label: 'RBM Code',
      
    },
    {
      key: 'prodcode',
      label: 'Prod code',
      
    },
    {
      key: 'proddesc',
      label: 'Product Description',
      
    },
    {
      key: 'proxycode',
      label: 'Proxy code',
      
    },
    {
      key: 'brand',
      label: 'Brand',
      
    },
    {
      key: 'm1_adjusted_budget_unit',
      label: String(Month1)+' Adj.Bug Unit',
     
    },
    {
      key: 'm1_adjusted_budget_value',
      label: String(Month1)+' Adj.Bug Val',
      
    },
    {
      key: 'nsp1',
      label: String(Month1)+' NSP',
      
    },
    {
      key: 'm2_adjusted_budget_unit',
      label: String(Month2)+' Adj.Bug Unit',
     
    },
    {
      key: 'm2_adjusted_budget_value',
      label: String(Month2)+' Adj.Bug Val',
      
    },
    {
      key: 'nsp2',
      label: String(Month2)+' NSP',
      
    },
    {
      key: 'm3_adjusted_budget_unit',
      label: String(Month3)+' Adj.Bug Unit',
     
    },
    {
      key: 'm3_adjusted_budget_value',
      label: String(Month3)+' Adj.Bug Val',
      
    },
    {
      key: 'nsp3',
      label: String(Month3)+' NSP',
      
    },
    
    
  ];
  return (
    <div className='bg-white home-screen'>
      <p style={{fontWeight:"550"}}>RBM Budget</p>
      <PeriodSelector/>
       <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>
            <select
              className="filter-style"
              id="brand"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
              value={selectedBrand}
            >
              {loaderFilter === true ? (
                <option value="">
                  Loading...
                </option>
              ) : (
                <option value="">select brand name</option>
                
              )}
              {brandComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Product Name
            </label>
            <select
              className="filter-style"
              id="product"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeProduct(event)}
              value={selectedProduct}
            >
               <option value="">select Product</option>
               {/* <option value="All">All</option> */}
              {productComponent}
            </select>
          </div>
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <button className="submit-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
        <div>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
            <CSVLink data={rows} headers={columns_buh} filename={"RBMBudget Summary.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>
          </button>
        </div>
      </div>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader===true?"true":"false"} />
        </div>
      ):(
      <RBMBudgetTable rows={rows} Month1={Month1} Month2={Month2} Month3={Month3}/>)}
         {loader === false ?(<div
        style={{
         
         height:"135px",
         width:"100%",
         marginBottom:"10px"
         
        }}
      >
      <table className='table-buh'>
  <tr className="table-tr-td-buh">
  <th className="table-tr-td-buh"></th>
    <th className="table-tr-td-buh">({Month1}) U</th>
    <th className="table-tr-td-buh">({Month1}) V</th>
    <th className="table-tr-td-buh">({Month1}) NSP</th>
    <th className="table-tr-td-buh">({Month2}) U</th>
    <th className="table-tr-td-buh">({Month2}) V</th>
    <th className="table-tr-td-buh">({Month2}) NSP</th>
    <th className="table-tr-td-buh">({Month3}) U</th>
    <th className="table-tr-td-buh">({Month3}) V</th>
    <th className="table-tr-td-buh">({Month3}) NSP</th>
  </tr>
  <tr className="table-tr-td-buh">
    <td className="table-tr-td-buh">Total</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_nsp_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_nsp_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_nsp_sum']}</td>
  </tr>
</table>
      </div>):""}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
        autoHideDuration={6000}
      />
    </div>
  )
}

export default RBMBuBudgetSummary
